module.exports = __webpack_public_path__ + "img/post.9f46b8de.png";